<div class="igo-search-settings">
  <button
    mat-icon-button
    class="igo-search-settings-button"
    color="primary"
    tooltip-position="below"
    matTooltipShowDelay="500"
    [matTooltip]="'igo.geo.search.menu.tooltip' | translate"
    [matMenuTriggerFor]="searchSettingsMenu"
  >
    <mat-icon>expand_more</mat-icon>
  </button>
  <mat-menu #searchSettingsMenu="matMenu" class="no-border-radius">
    @if (getSearchSources().length > 4) {
      <div class="checkAllButton">
        <button matButton="elevated" (click)="checkUncheckAllSources($event)">
          {{
            !searchSourcesAllEnabled
              ? ('igo.geo.search.searchSources.unselectAll' | translate)
              : ('igo.geo.search.searchSources.selectAll' | translate)
          }}
        </button>
      </div>
    }
    @for (source of getSearchSources(); track source) {
      <span class="igo-search-settings-search-source">
        <mat-checkbox
          class="igo-search-settings-checkbox"
          [checked]="source.enabled"
          [value]="$any(source)"
          (click)="$event.stopPropagation()"
          (change)="onCheckSearchSource($event, source)"
        />
        @if (source.settings.length > 0) {
          <button [matMenuTriggerFor]="sub_menu" mat-menu-item>
            {{ source.title }}
          </button>
        }
        @if (source.settings.length === 0) {
          <button mat-menu-item>
            {{ source.title }}
          </button>
        }
      </span>
      <mat-menu #sub_menu="matMenu">
        @for (setting of source.settings; track setting) {
          <button mat-menu-item [matMenuTriggerFor]="test_sub_menu">
            {{
              'igo.geo.search.searchSources.settings.' + setting.title
                | translate
            }}
          </button>
          <mat-menu #test_sub_menu="matMenu" yPosition="above">
            @switch (setting.type) {
              @case ('radiobutton') {
                <span>
                  <mat-radio-group
                    class="igo-search-settings-radio-group"
                    [value]="setting"
                  >
                    @for (settingValue of setting.values; track settingValue) {
                      <mat-radio-button
                        [value]="settingValue"
                        [matTooltip]="getAvailableHashtagsValues(settingValue)"
                        [checked]="settingValue.enabled"
                        (click)="$event.stopPropagation()"
                        (change)="
                          settingsValueCheckedRadioButton(
                            $event,
                            source,
                            setting,
                            settingValue
                          )
                        "
                      >
                        {{ settingValue.title | translate }}
                      </mat-radio-button>
                    }
                  </mat-radio-group>
                </span>
              }
              @case ('checkbox') {
                <span>
                  @if (setting.values.length > 3) {
                    <div class="checkAllButton">
                      <button
                        matButton="elevated"
                        (click)="checkUncheckAll($event, source, setting)"
                      >
                        {{
                          setting.allEnabled || setting.allEnabled === undefined
                            ? ('igo.geo.search.searchSources.settings.unselectAll'
                              | translate)
                            : ('igo.geo.search.searchSources.settings.selectAll'
                              | translate)
                        }}
                      </button>
                    </div>
                  }
                  @for (
                    settingValue of getAvailableValues(setting);
                    track settingValue
                  ) {
                    <div class="igo-search-settings-sub-menu" mat-menu-item>
                      <mat-checkbox
                        [style.display]="displayBlock"
                        [checked]="settingValue.enabled"
                        [value]="$any(setting)"
                        [matTooltip]="getAvailableHashtagsValues(settingValue)"
                        (click)="$event.stopPropagation()"
                        (change)="
                          settingsValueCheckedCheckbox(
                            $event,
                            source,
                            setting,
                            settingValue
                          )
                        "
                      >
                        {{ settingValue.title | translate }}
                      </mat-checkbox>
                    </div>
                  }
                </span>
              }
            }
          </mat-menu>
        }
      </mat-menu>
    }
    <mat-divider />
    <span class="pointer-summary-slide-toggle-container">
      @if (hasPointerReverseSearchSource && !isTouchScreen) {
        <div mat-menu-item>
          <mat-slide-toggle
            class="search-option"
            (change)="changePointerReverseSearch($event)"
            tooltip-position="below"
            matTooltipShowDelay="500"
            [matTooltip]="
              'igo.geo.search.pointerSearchSummary.tooltip' | translate
            "
            (click)="$event.stopPropagation()"
            [checked]="pointerSummaryEnabled()"
          >
            {{ 'igo.geo.search.pointerSearchSummary.title' | translate }}
          </mat-slide-toggle>
        </div>
      }
      <div mat-menu-item>
        <mat-slide-toggle
          class="search-option"
          (change)="changeSearchResultsGeometry($event)"
          tooltip-position="below"
          matTooltipShowDelay="500"
          [matTooltip]="
            'igo.geo.search.searchResultsGeometry.tooltip' | translate
          "
          (click)="$event.stopPropagation()"
          [checked]="searchResultsGeometryEnabled()"
        >
          {{ 'igo.geo.search.searchResultsGeometry.title' | translate }}
        </mat-slide-toggle>
      </div>
      <div mat-menu-item>
        <mat-slide-toggle
          class="search-option"
          (change)="reverseSearchCoordsFormat($event)"
          tooltip-position="below"
          matTooltipShowDelay="500"
          [matTooltip]="
            reverseSearchCoordsFormatEnabled()
              ? ('igo.geo.search.reverseCoordFormat.tooltipLatLon' | translate)
              : ('igo.geo.search.reverseCoordFormat.tooltipLonLat' | translate)
          "
          (click)="$event.stopPropagation()"
          [checked]="reverseSearchCoordsFormatEnabled()"
        >
          {{ 'igo.geo.search.reverseCoordFormat.title' | translate }}
        </mat-slide-toggle>
      </div>
      @if (allowResetSearchSourcesOptions()) {
        <div mat-menu-item>
          <button
            matButton="elevated"
            class="check-default-button"
            (click)="resetSourceOptions($event)"
          >
            {{
              'igo.geo.search.searchSources.settings.reset.button' | translate
            }}
          </button>
        </div>
      }
    </span>
  </mat-menu>
</div>
